import client from "./Client";

const newRestAPI = (url) => {
  return {
    getOne: async (id) => {
      const { data } = await client.get(`${url}/${id}`);
      return data;
    },
    getAll: async () => {
      const { data } = await client.get(url);
      return data;
    },
    getPaged: async (page, perPage = 15) => {
      const { data, headers } = await client.get(
        `${url}?page=${page}&per_page=${perPage}`
      );
      return { ...data, headers };
    },
    update: async (toUpdate) => {
      const { data } = await client.put(`${url}/${toUpdate.id}`, toUpdate);
      return data;
    },
    create: async (toCreate) => {
      const { data } = await client.post(url, toCreate);
      return data;
    },
    delete: async (id) => {
      const { data } = await client.delete(`${url}/${id}`);
      return data;
    },
  };
};

export default newRestAPI;
